'use client';

import React from 'react';
import Footer, { FooterLogo, LegalText } from 'components/commercetools-ui/organisms/footer';
import { FooterColumn, FooterLink } from 'components/commercetools-ui/organisms/footer/atoms/column';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import { TasticProps } from '../types';


interface NavColumn {
  header: string;
  headerTextColor?: string;
  headerTextSize?: string;
  headerTextStyle?: string;
  links: FooterLink[];
  linkTextColor?: string;
  linkTextSize?: string;
  linkTextStyle?: string;
}

export interface Props {
  [key: `navCol${number}`]: NavColumn[];
  legalText: LegalText[];
  footerBgColor: string;
  footerBgImage: ImageProps;
  footerLogo: FooterLogo[];
}

const GMSBFooterTastic = ({ data }: TasticProps<Props>) => {
  let columns: FooterColumn[] = [];
  const columnKeys = Object.keys(data).filter((key) => /^navCol\d+$/.test(key));
  if (columnKeys.length > 0) {
    columns = columnKeys.reduce<FooterColumn[]>((acc, column) => {
      const colData = (data as Record<string, any>)[column]?.[0];
      if (colData) {
        acc.push({
          ...colData
        });
      }

      return acc;
    }, []);
  }


  return (
    <div className="mx-[0] sm:mx-[24px] md:mx-[75px] lg:mx-[76px] xl:mx-0 px-20 sm:px-0 fixed-screen-width lg:relative-width">
      <Footer legalText={data.legalText[0]} footerLogo={data.footerLogo[0]} footerBgColor={data.footerBgColor} footerBgImage={data.footerBgImage} columns={columns} />
    </div>
  );
};

export default GMSBFooterTastic;
